import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Gift, Copy, ArrowSquareOut } from '@phosphor-icons/react';
import { Md } from '@/components/Md';
import { resourceIcon } from '@/lib/resourceIcons';

const API = process.env.REACT_APP_BACKEND_URL;

export default function RecomendacoesClientPage() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/my-recommendations`);
        setGroups(data.groups || []);
      } catch {} finally { setLoading(false); }
    })();
  }, []);

  const copyCode = (code) => { navigator.clipboard.writeText(code); toast.success('Código copiado'); };

  if (loading) return <div className="text-center py-12 text-brand-muted">A carregar...</div>;

  const totalItems = groups.reduce((n, g) => n + g.items.length, 0);

  return (
    <div className="fade-in" data-testid="recomendacoes-client-page">
      <div className="mb-5">
        <h2 className="font-heading font-medium text-xl text-brand-text">Recomendações</h2>
        <p className="text-xs text-brand-muted mt-1">Recursos selecionados pela tua nutricionista</p>
      </div>

      {totalItems === 0 ? (
        <div className="text-center py-16">
          <Gift size={48} className="mx-auto text-brand-placeholder mb-4" weight="duotone" />
          <p className="text-brand-muted text-sm">Sem recomendações de momento.</p>
        </div>
      ) : (
        <div className="space-y-5">
          {groups.map(group => {
            const Icon = resourceIcon(group.category.icon);
            return (
              <div key={group.category.id || 'outros'} data-testid={`rec-group-${group.category.id || 'outros'}`}>
                <div className="flex items-center gap-2 mb-2">
                  <Icon size={16} className="text-brand-green" weight="duotone" />
                  <h3 className="font-heading font-medium text-sm text-brand-text">{group.category.name}</h3>
                </div>
                <div className="space-y-2">
                  {group.items.map(item => (
                    <div key={item.id} className={`border rounded-2xl p-4 ${item.type === 'discount' ? 'bg-amber-50/50 border-amber-200' : 'bg-white border-brand-border'}`} data-testid={`rec-client-${item.id}`}>
                      {item.type === 'discount' ? (
                        <div>
                          <h4 className="text-sm font-medium text-brand-text">{item.title}</h4>
                          {item.description && <Md as="p" className="text-xs text-brand-muted mt-0.5">{item.description}</Md>}
                          {item.content && (
                            <div className="mt-2 flex items-center gap-2">
                              <div className="bg-white border-2 border-dashed border-amber-300 rounded-xl px-4 py-2 flex-1">
                                <span className="font-mono font-bold text-amber-700 text-lg">{item.content}</span>
                              </div>
                              <button onClick={() => copyCode(item.content)} className="bg-amber-600 text-white rounded-xl px-3 py-2.5 text-xs font-medium flex items-center gap-1 hover:bg-amber-700" data-testid={`copy-code-${item.id}`}>
                                <Copy size={14} /> Copiar
                              </button>
                            </div>
                          )}
                          {item.url && <a href={item.url} target="_blank" rel="noreferrer" className="text-xs text-amber-600 hover:underline mt-2 inline-flex items-center gap-1">Usar desconto <ArrowSquareOut size={12} /></a>}
                        </div>
                      ) : (
                        <a href={item.url} target="_blank" rel="noreferrer" className="flex items-start gap-3 group">
                          <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 bg-brand-green/10 text-brand-green">
                            <Icon size={18} weight="duotone" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <h4 className="text-sm font-medium text-brand-text group-hover:text-brand-green transition-colors">{item.title}</h4>
                            {item.description && <Md as="p" className="text-xs text-brand-muted mt-0.5">{item.description}</Md>}
                            {item.url && <p className="text-[10px] text-brand-green mt-0.5 truncate flex items-center gap-0.5">{item.url} <ArrowSquareOut size={10} /></p>}
                          </div>
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
